import { Form, Input } from "antd";
import React from "react";

interface SubjectUserNameProps {
  isDisable: boolean;
}
const SubjectUsername: React.FC<SubjectUserNameProps> = (props) => {
  const { isDisable } = props;
  return (
    <Form.Item
      name={["managingUser", "systemUser", "username"]}
      label="Username"
      rules={[
        {
          required:false,
          message: "Please enter the Username",
        },
      ]}
    >
      <Input disabled={isDisable} />
    </Form.Item>
  );
};

export default SubjectUsername;
